/* eslint-disable max-lines-per-function */

import classNames from 'classnames'
import gaugeType from '../Utils/gauageUtils'

export type TGaugeProps = {
  radius: number
  percent: number
  type: string
}

export default function INGauge(props: TGaugeProps) {
  const { radius, percent, type } = props

  const strokeWidth = radius * 0.15
  const innerRadius = radius - strokeWidth / 2
  const circumference = innerRadius * 2 * Math.PI
  const arc = circumference * (180 / 360)
  const dashArray = `${arc} ${circumference}`
  const transform = `rotate(180, ${radius}, ${radius})`

  const percentNormalized = Math.min(Math.max(percent, 0), 100)
  const offset = arc - (percentNormalized / 100) * arc

  // 1 slash
  const arcSlash1 = circumference * (2 / 360)
  const dashArraySlash1 = `${arcSlash1} ${circumference}`
  const transformSlash1 = `rotate(225, ${radius}, ${radius})`

  // 2 slash
  const arcSlash2 = circumference * (2 / 360)
  const dashArraySlash2 = `${arcSlash2} ${circumference}`
  const transformSlash2 = `rotate(270, ${radius}, ${radius})`

  // 3 slash
  const arcSlash3 = circumference * (2 / 360)
  const dashArraySlash3 = `${arcSlash3} ${circumference}`
  const transformSlash3 = `rotate(315, ${radius}, ${radius})`
  const { degreeOfDial, typeTxt, color } = gaugeType({ type })

  return (
    <div>
      <div className="-mb-18 relative mt-5 flex w-fit justify-center">
        <svg height={radius * 2} width={radius * 2}>
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="3.11%" stopColor="#33A34D" />
              <stop offset="21.23%" stopColor="#B3DA60" />
              <stop offset="70.47%" stopColor="#DE6A16" />
              <stop offset="100%" stopColor="#DF3C27" />
            </linearGradient>
          </defs>

          <circle
            cx={radius}
            cy={radius}
            fill="transparent"
            r={innerRadius}
            stroke="url(#gradient)"
            strokeDasharray={dashArray}
            strokeDashoffset={offset}
            strokeWidth={strokeWidth}
            transform={transform}
          />

          {/* slash 1 */}
          <circle
            cx={radius}
            cy={radius}
            fill="transparent"
            r={innerRadius}
            stroke="white"
            strokeDasharray={dashArraySlash1}
            strokeWidth={strokeWidth}
            transform={transformSlash1}
          />

          {/* slash 2 */}
          <circle
            cx={radius}
            cy={radius}
            fill="transparent"
            r={innerRadius}
            stroke="white"
            strokeDasharray={dashArraySlash2}
            strokeWidth={strokeWidth}
            transform={transformSlash2}
          />
          <circle
            cx={radius}
            cy={radius}
            fill="transparent"
            r={innerRadius}
            stroke="white"
            strokeDasharray={dashArraySlash3}
            strokeWidth={strokeWidth}
            transform={transformSlash3}
          />
          <path
            fill="currentColor"
            d="M -63.2702 -0.7894 a 0.744 0.744 90 0 0 -0.0025 1.4851 l 59.377 2.9489 a 3.602 3.602 90 1 0 0.0113 -7.1978 L -63.2706 -0.7885 Z"
            style={{
              transform: `translate(100px, 100px) rotate(${degreeOfDial})`,
            }}
          />
          <circle
            cx={radius}
            cy={radius}
            r={10}
            fill="#F5F5F8"
            stroke="#BDBDBD"
            strokeWidth={1}
            style={{
              filter: 'drop-shadow( 0px 1px 6px rgba(0, 0, 0, 0.08))',
            }}
          />
        </svg>

        <div className="text-grey text-sm">
          <div>
            <p className="absolute -left-[10px] top-[9px] -rotate-[52deg] transform">
              Bearish
            </p>
            <p className="absolute -top-[27px] left-[76px]">Neutral</p>
            <p className="absolute -right-[17px] top-[13px] rotate-[52deg] transform px-2">
              Bullish
            </p>
          </div>
        </div>
      </div>
      <span className={classNames('flex justify-center text-center', color)}>
        {typeTxt}
      </span>
    </div>
  )
}
